import { render, staticRenderFns } from "./newOrder.vue?vue&type=template&id=2a8a21da&scoped=true&"
import script from "./newOrder.vue?vue&type=script&lang=js&"
export * from "./newOrder.vue?vue&type=script&lang=js&"
import style0 from "./newOrder.vue?vue&type=style&index=0&id=2a8a21da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8a21da",
  null
  
)

export default component.exports